<template>
  <div class="nav-container">
    <img v-if="checkIsPrincipal" class="logo-Principal" src="https://static.dx.principal.cl/fulfillment/assets/auth/facial/Principal_logo.png"  alt="Principal" />
    <img v-else class="logo-Cuprum" src="https://static.dx.principal.cl/fulfillment/assets/auth/facial/Cuprum_logo.png" alt="Cuprum" />
  </div>
</template>

<script>
export default {
  name: "Nav",
  props: {
    company: { type: String, default: "principal" },
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    checkIsPrincipal(){
      return this.company === "principal"
    }
  }
};
</script>

<style scoped>
.nav-container {
  background-color: #035fa4;
  display: flex;
  height: 40px;
  align-items: flex-start;
  width: -webkit-fill-available;
}

.logo-Principal {
  height: 26px;
  width: 90px;
  padding: 8px;
}

.logo-Cuprum {
  height: 31px;
  width: 89px;
  padding: 8px;
}
</style>
